<template>
  <v-card
    class="business__bg"
  >
    <v-container
      fluid
      class="fill-height"
    >
      <v-row
        justify="center"
        align="center"
        class="text-center white pa-2 mt-8 business__row"
      >
        <div
          class="business__icon-container"
        >
          <component
            :is="exclamationCircleIcon"
            class="exclamation-circle__icon"
          />
        </div>
        <span class="title text-uppercase ml-2 primary--text font-weight-regular">Funcionalidade <b>exclusiva</b> do plano business</span>
      </v-row>
    </v-container>
    <v-card-text
      class="text-center mt-4"
    >
      <span class="title white--text" v-html="current.content"/>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="accent"
        tile
        @click="onClose"
      >
        Depois
      </v-btn>
      <v-btn
        color="pink lighten-1"
        class="white--text"
        tile
        @click="onConfirm"
      >
        Assinar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "BusinessOnlyCard",
    props: {
      current: {
        type: Object,
        required: true
      }
    },
    methods: {
      onClose() {
        this.$emit("close")
      },
      onConfirm() {
        this.$emit("close")
        this.$router.push('/app/plans')
      }
    },
    computed: {
      exclamationCircleIcon() {
        const SVGIcon = require("../../../assets/icons/exclamation-circle.svg?inline")
        return SVGIcon.default
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../sass/mixins";

  .business__bg {
    background-image: url("../../../assets/general/background-stripped-blue.png");
    background-size: cover;
  }

  .business__row {
    max-height: 50px;
    @include display-xs-only {
      max-height: unset;
    }
  }

  .business__icon-container {
    display: flex;
    position: relative;
    align-self: start;
    width: 68px;
    height: auto;
    @include display-xs-only {
      display: none !important
    }
  }

  .exclamation-circle__icon {
    position: absolute;
    font-size: 68px;
    width: 68px;
    height: 68px;
    top: 0;
    left: 0;
    transform: translateY(-26%);
  }

</style>
